export default __webpack_public_path__ + "static/brauhaus-vanhans-preview-5493743c87923fbe9ea3a94bff9446c8.jpg";